import React from "react";

// import Achievements from "../assets/icons/achivements.svg?react";
// import Certificates from "../assets/icons/certificates.svg?react";
// import Education from "../assets/icons/education.svg?react";
// import Experience from "../assets/icons/experience.svg";
// import Location from "../assets/icons/location.svg?react";
// import Project from "../assets/icons/projects.svg?react";
// import Skill from "../assets/icons/skill.svg?react";

// export const AchievementsIcon = (props) => <Achievements {...props} />;
// export const CertificatesIcon = (props) => <Certificates {...props} />;
// export const EducationIcon = (props) => <Education {...props} />;
// // export const ExperienceIcon = (props) => <Experience {...props} />;
// export const LocationIcon = (props) => <Location {...props} />;
// export const ProjectIcon = (props) => <Project {...props} />;
// export const SkillIcon = (props) => <Skill {...props} />;

export const ICONS = {
  // education: <EducationIcon />,
  // // experience: <ExperienceIcon />,
  // projects: <ProjectIcon />,
  // skills: <SkillIcon />,
  // achievement: <AchievementsIcon />,
  // soft_skills: <SkillIcon />,
  // certificates: <CertificatesIcon />,
  // certificate: <CertificatesIcon />,
  // achievements: <AchievementsIcon />,
  // location: <LocationIcon />,
};
